/**
 * What's New (M57): short plain-word notes per release, newest first. After an update, the notes
 * newer than the ones this browser last saw are shown once; Settings → What's new lists them all.
 * Someone opening the app for the first time isn't shown old notes. Notes are keys into the
 * catalogs (English, Russian and Korean), so every language gets the same list.
 */
import type { MessageKey } from './i18n-catalog.ts';

export interface ReleaseNotes { id: string; date: string; items: MessageKey[] }
/** Newest first; an id only ever grows (YYYY-MM-DD, with a suffix for a second release that day). */
export const RELEASE_NOTES: ReleaseNotes[] = [
  { id: '2026-11-03', date: '2026-11-03', items: ['news.2026-11-03.update', 'news.2026-11-03.timeline', 'news.2026-11-03.storage', 'news.2026-11-03.export', 'news.2026-11-03.recovery'] },
];
export const SEEN_KEY = 'miraops.whatsNew.seen';
const latest = () => RELEASE_NOTES[0]?.id ?? '';

/** Notes to show once on opening: those newer than the last seen; none the first time (and that is remembered). */
export function notesToShow(storage: Pick<Storage, 'getItem' | 'setItem'> | null): ReleaseNotes[] {
  try {
    const seen = storage?.getItem(SEEN_KEY) ?? null;
    if (seen === null) { storage?.setItem(SEEN_KEY, latest()); return []; }
    return RELEASE_NOTES.filter(n => n.id > seen);
  } catch { /* ignored: browser storage blocked: never nag on every visit */  return []; } // Storage blocked: never nag on every visit.
}
/** Remember that the latest notes were seen. */
export function markNotesSeen(storage: Pick<Storage, 'setItem'> | null) {
  try { storage?.setItem(SEEN_KEY, latest()); } catch { /* storage blocked: shown again next time */ }
}
